export enum Permission {
  ADMIN = 'admin',
  CORE_CHANGE = 'core:change',
  ROUTINE_RUN = 'routine:run',
  FINANCE_CHANGE = 'finance:change',
  CAMPAIGN_CHANGE = 'campaign:change',
  READ_ONLY = 'read:only',
  AUX_SECRETARY = 'aux:secretary',
  YOUTH_CHANGE = 'youth:change',
  YOUTH_ADMIN = 'youth:admin',
  AUX_YOUTH = 'aux:youth',
  CAMPAIGN_ADD = 'campaign:add',
  TEACHER = 'teacher',
  STUDENT = 'student'
}
